<template>
    <div class="widget-inner">
        <div class="widget-empty-message" v-if="!content.entries.length">
            <div v-if="isPersonalDashboardWidget" :style="{color}">
                {{widget.emptyMessage}}
            </div>
            <template v-else>
                <i class="material-icons md-96" aria-hidden="true" role="img">{{widget.emptyIcon}}</i>
                <br/>
                {{widget.emptyMessage}}
            </template>
        </div>
        <ul class="widget-content" v-else>
            <li class="flex"
                :class="{'background-today': isToday(entry.created)}"
                v-for="entry in content.entries">
                <div v-if="entry.paths && entry.paths.medium || entry.icon" class="flex flex-center widget-image-holder">
                    <img class="widget-image" :src="entry.paths.medium" v-if="entry.paths && entry.paths.medium" alt="Vorschaubild"/>
                    <i class="material-icons" aria-hidden="true"
                        :style="{color: entry.iconColor && entry.iconColor.startsWith('#') ? entry.iconColor : ('rgb(' + entry.iconColor + ')')}"
                        v-else-if="entry.icon" role="img">{{entry.icon}}</i>
                </div>
                <div class="text-overflow">
                    <router-link :to="entry.link" v-if="entry.link">{{entry.title}}</router-link>
                    <router-link v-else :to="{name: widget.viewRoute, params: entry}">{{entry.title}}</router-link>
                    <small>
                        <template v-if="entry.created">
                            {{dateHelper('d.m.Y', entry.created)}}
                        </template>
                        <template v-if="entry.creator">
                            von {{getUsername(entry.creator)}}
                        </template>
                    </small>
                </div>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
    import {State} from 'vuex-facing-decorator';
    import {getUsername} from '../../filters/username';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import dateHelper, {isToday} from '../../utils/portuna/dateHelper';

    @Component({
        name: 'WidgetDefault',
        methods: {
            dateHelper,
            isToday,
            getUsername,
        },
    })
    export class WidgetDefault extends Vue
    {
        @State('layoutData') layoutData: LayoutData;

        @Prop({
            type: Object,
            required: true,
        }) widget: WidgetData;

        @Prop({
            type: Object,
            required: true,
        }) content: WidgetContentProp;

        get isPersonalDashboardWidget(): boolean
        {
            return !!this.widget.isPersonalDashboardPopupWidget;
        }

        get color(): string
        {
            return this.widget.color
                ? this.widget.color.startsWith('#') || this.widget.color.startsWith('rgb') ? this.widget.color : ('#' + this.widget.color)
                : this.layoutData.colors['rgb-color-headline'];
        }
    }

    export default WidgetDefault;
</script>